import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faInfo } from "@fortawesome/free-solid-svg-icons";
import {
  InputRowContainer,
  InputContainer,
  Label,
  InputComponent,
  PopoverLeft,
  Instructions,
} from "./password-components";
import { Error } from "@app/components/input/input-components";

type Props = {
  label?: string;
  placeholder?: string;
  name?: string;
  value?: string;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  register?: any;
  showInfo?: boolean;
  disable?: boolean;
  hideLabel?: boolean;
  error?: string;
  showInstructions?: boolean;
  autoFocus?: boolean;
  defaultValue?: string
  hideIcon?: boolean
  defaultPasswordvisiblility?: boolean;
};

export default function Password({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  register,
  showInfo,
  disable,
  hideLabel,
  defaultValue,
  error,
  showInstructions,
  autoFocus,
  hideIcon,
  defaultPasswordvisiblility
}: Props) {
  const [showpassword, setShowPassword] = React.useState(defaultPasswordvisiblility ? defaultPasswordvisiblility : false);
  const toggleShowPassword = async () => {
    if (hideIcon) {
      setShowPassword(!showpassword);
    } else {
      setShowPassword(!showpassword);
    }

  };
  const [anchorEl, setAnchorEl] = React.useState<boolean>(false);

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(true);
  };

  const handlePopoverClose = () => {
    setAnchorEl(false);
  };

  return (
    <>
      <InputRowContainer>
        {label && <Label className={hideLabel ? "hide" : ""}>{label}</Label>}
        <InputContainer className={showInfo ? "with-info" : ""}>
          <InputComponent
            className={showInfo ? "with-info" : ""}
            type={showpassword ? "text" : "password"}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            ref={register}
            defaultValue={defaultValue}
            disabled={disable}
            autoFocus={autoFocus}
          // onPaste={(e: any) => e.preventDefault()}
          />
          {hideIcon && <FontAwesomeIcon
            className="password-icon"
            icon={showpassword ? faEye : faEyeSlash}
            onClick={toggleShowPassword}
            style={{ cursor: "pointer" }}
          />}
          {showInfo && (
            <>
              <FontAwesomeIcon
                icon={faInfo}
                color="#00BE9A"
                className="info-icon"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
              />
              {anchorEl && (
                <PopoverLeft>
                  Password must contain: 8-20 Characters with at least 1 Upper
                  Case, 1 Lower Case, 1 Numeric Character and 1 Special
                  Character
                </PopoverLeft>
              )}
            </>
          )}
        </InputContainer>
        {error && <Error>{error}</Error>}
        {showInstructions && (
          <Instructions>
            <p>
              Password must contain 8-20 characters.
            </p>
            <p>
              Atleast 1 Uppercase, 1 Lowercase, 1 Numeric Character
              and 1 Special Character.
            </p>
          </Instructions>
        )}
      </InputRowContainer>
    </>
  );
}
